export default "<!-- <app-admin-menu></app-admin-menu> -->\n\n<section>\n\n    <app-admin-menu></app-admin-menu>\n</section>"